module.exports = __webpack_public_path__ + "static/media/ulip.866233e3.mp3";